import React from 'react';
import { FaCalendarAlt } from 'react-icons/fa';
import { SectionCard, StatusBadge, DataTable, formatDate } from './ui';
import { getAttendanceLeaveTypeLabel } from '../../../libs/attendance';

export interface UpcomingTeamLeaves {
  from_date: string;
  to_date: string;
  /** People below the signed-in user in the reporting hierarchy. */
  team_size: number;
  total: number;
  leaves: Array<{
    id: number;
    user_id: number;
    employee: string | null;
    employee_code: string | null;
    leave_type: string;
    start_date: string;
    end_date: string;
    total_days: number;
    status: string;
    reason: string | null;
  }>;
}

/**
 * Leaves applied by the signed-in user's team for the next 7 days, today
 * included: pending and approved leave applications of everyone below them in
 * the reporting hierarchy. Hidden for a user nobody reports to.
 */
export const UpcomingTeamLeavesCard: React.FC<{ data?: UpcomingTeamLeaves | null }> = ({ data }) => {
  if (!data || !data.team_size) return null;

  return (
    <SectionCard
      title="Team Leaves — Next 7 Days"
      subtitle={`${formatDate(data.from_date)} to ${formatDate(data.to_date)} · ${data.total} leave${data.total === 1 ? '' : 's'}`}
      icon={FaCalendarAlt}
    >
      <DataTable
        columns={[
          { key: 'employee', label: 'Employee', render: (item) => item.employee || '—' },
          { key: 'employee_code', label: 'E-Code', render: (item) => item.employee_code || '—' },
          { key: 'leave_type', label: 'Leave Type', render: (item) => getAttendanceLeaveTypeLabel(item.leave_type) },
          { key: 'start_date', label: 'From', render: (item) => formatDate(item.start_date) },
          { key: 'end_date', label: 'To', render: (item) => formatDate(item.end_date) },
          { key: 'total_days', label: 'Days', align: 'center' },
          { key: 'status', label: 'Status', render: (item) => <StatusBadge status={item.status} /> },
        ]}
        data={data.leaves}
        maxHeight="320px"
        emptyMessage="Nobody in your team has applied for leave in the next 7 days"
      />
    </SectionCard>
  );
};

export default UpcomingTeamLeavesCard;
